import { render, staticRenderFns } from "./FuturePackages.vue?vue&type=template&id=06e1f7b8&"
import script from "./FuturePackages.vue?vue&type=script&lang=js&"
export * from "./FuturePackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports